import Immutable, { Record as record, Map, List } from 'immutable';

import { construct, resolve, resolveAll } from '../helpers/LinkMapper';

const defaults = {
    id: null,
    nlc: null,
    crs: null,
    name: null,
    categories: new List(),
    latitude: null,
    longitude: null,
    validity: new Map(),
    onwardTaxiBookingAvailable: false,
    gazetteer: null,
    facilities: null,
    weeklyCapAvailable: false,
    accessibilityData: new Map()
};

class Station extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(Station, json, {
            id: json.id,
            nlc: resolve.with(String),
            crs: resolve.with(String),
            name: resolve.with(String),
            categories: resolveAll.with(String),
            latitude: resolve.with(Number),
            longitude: resolve.with(Number),
            validity: resolve.with(Map),
            onwardTaxiBookingAvailable: resolve.with(Boolean),
            gazetteer: resolve.with(Immutable.fromJS),
            facilities: json.facilities,
            weeklyCapAvailable: resolve.with(Boolean),
            accessibilityData: resolve.with(Map),
        });
    }

    getAccessibilityData () {
        return this.get('accessibilityData');
    }

    getName () {
        return this.get('name');
    }

    getCrs () {
        return this.get('crs');
    }

    isTravelcard () {
        return ["0034", "0035"].includes(this.nlc);
    }

    isLondonStation () {
        return this.gazetteer && this.gazetteer.get('londonZones', new List()).size > 0;
    }

    isLondonTerminals () {
        return this.nlc === "1072";
    }

    isEmpty () {
        return this.nlc === defaults.nlc;
    }

    getLatLng () {
        return { lat: this.latitude, lng: this.longitude };
    }

    isWithinGoldcardArea () {
        return this.gazetteer && this.gazetteer.get('withinGoldcardArea');
    }

    isGroupStation () {
        return !this.getCrs() && this.categories.includes('NationalRail');
    }
}

export default Station;



// WEBPACK FOOTER //
// ./src/records/Station.js